import {
    AssistantShiftProfile,
    PrinterMachineColumn,
    PrinterShift,
    PrinterShiftProfile,
} from '../../../types/api/user'
import { PRINTER_MACHINE_COLUMNS, PRINTER_SHIFTS } from '../constants/shift-grid'

function hasShift(value: unknown): value is { data: { shift: PrinterShift } } {
    if (!value || typeof value !== 'object') {
        return false
    }

    const candidate = value as { data?: { shift?: unknown } }

    return PRINTER_SHIFTS.includes(candidate.data?.shift as PrinterShift)
}

export function isPrinterShiftProfile(value: unknown): value is PrinterShiftProfile {
    if (!hasShift(value)) {
        return false
    }

    const candidate = value as PrinterShiftProfile

    return (
        candidate.type === 'printer' &&
        PRINTER_MACHINE_COLUMNS.includes(candidate.data.machineColumn as PrinterMachineColumn)
    )
}

export function isAssistantShiftProfile(value: unknown): value is AssistantShiftProfile {
    if (!hasShift(value)) {
        return false
    }

    return (value as AssistantShiftProfile).type === 'assistant'
}
